import { FC, memo } from 'react'
import { useTranslation } from 'react-i18next'
import { FaEye, FaPencilAlt, FaTrashAlt } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'

import { Button, Tooltip, useTheme } from '@mui/material'
import { actionIcon, eyeIcon, pencilIcon, trashIcon } from 'utils/customizedTheme'

interface IProps {
  row: any
  params?: any[]
  baseUrl?: string
  idField?: string
  hash?: string
  color?: 'black' | 'white' | ''
  overridePermissions?: boolean
}

const MainTableActionButtons: FC<IProps> = memo(({ 
  row, 
  baseUrl = '', 
  idField = 'id', 
  params = [], 
  hash = '', 
  color = '',
  overridePermissions = false}) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const navigate = useNavigate()
  

  return (
    <> 
      {row?.actions?.is_viewable && !row?.actions?.is_editable && (
        <Tooltip title={`${t('common.view')}`} arrow placement='top'>
          <Button
            onClick={() => navigate(`${baseUrl}view/${row[idField]}${hash ? '#'+hash : ''}`)}
            variant='outlined'
            color={color ? color : 'primary'}
            disableElevation
            sx={{ ...actionIcon, ...eyeIcon }}
          >
            <FaEye />
          </Button>
        </Tooltip>
      )}

      {(overridePermissions || row?.actions?.is_editable) && (
        <Tooltip title={`${t('common.edit')}`} arrow placement='top'>
          <Button
            onClick={() => navigate(`${baseUrl}edit/${row[idField]}${params ? '?' + params.map(p => p.k+'='+p.v+'&') : ''}${hash ? '#'+hash : ''}`)}
            variant='outlined'
            color={color ? color : 'green'}
            disableElevation
            sx={{ ...actionIcon, ...pencilIcon }}
          >
            <FaPencilAlt />
          </Button>
        </Tooltip>
      )}

      {(overridePermissions || row?.actions?.is_deletable) && (
        <Tooltip title={`${t('common.delete')}`} arrow placement='top'>
          <Button
            onClick={() => navigate(`${baseUrl}delete/${row.id}${params ? '?' + params.map(p => p.k+'='+p.v+'&') : ''}`)}
            variant='outlined'
            color={color ? color : 'error'}
            disableElevation
            sx={{ ...actionIcon, ...trashIcon }}
          >
            <FaTrashAlt />
          </Button>
        </Tooltip>
      )}
    </>
  )
})

export default MainTableActionButtons
